import template from './component.tpl.html';
import AlGuestlistEditorComponentController from './controller';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-editor-page-form guestlist="{}"></al-guestlist-editor-page-form>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistEditorPageForm', {
        bindings: {
            guestlist: '<',
            onModelUpdate: '&',
            availableFields: '<',
            enabledFields: '<',
            globalModel: '<',
            showContent: '<',
            customFieldDefinitions: '<',
            onCustomFieldChange: '&',
            onEnabledFieldsUpdate: '&'
        },
        controller: AlGuestlistEditorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/pages/form/component.js